import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Archive = createReactComponent("Archive", ["svg", defaultAttributes, [["polyline", {
  points: "21 8 21 21 3 21 3 8",
  key: "o37y8j"
}], ["rect", {
  x: "1",
  y: "3",
  width: "22",
  height: "5",
  key: "6p2xdd"
}], ["line", {
  x1: "10",
  y1: "12",
  x2: "14",
  y2: "12",
  key: "i3jslw"
}]]]);
export default Archive;